const salarySacrificeTable = [
  [50, 500, 600, 316.23],
  [55, 685, 660, 347.86],
  [60, 875, 720, 379.48],
  [65, 1000, 780, 411.1],
  [70, 1195, 840, 442.73],
  [75, 1325, 900, 474.35],
  [80, 1535, 960, 505.97],
  [85, 1730, 1020, 537.6],
  [90, 1920, 1080, 569.22],
  [95, 2115, 1140, 600.84],
  [100, 2310, 1200, 632.47],
  [105, 2480, 1260, 664.09],
  [110, 2605, 1320, 695.71],
  [115, 2805, 1380, 727.34],
  [120, 3000, 1440, 758.96],
  [125, 3160, 1500, 790.58],
  [130, 3310, 1560, 822.21],
  [135, 3470, 1620, 853.83],
  [140, 3620, 1680, 885.46],
  [145, 3775, 1740, 917.08],
  [150, 3925, 1800, 948.7],
  [155, 4080, 1860, 980.33],
  [160, 4230, 1920, 1011.95],
  [165, 4385, 1980, 1043.57],
  [170, 4535, 2040, 1075.2],
  [175, 4685, 2100, 1106.82],
  [180, 4835, 2160, 1138.44],
  [185, 4950, 2220, 1170.07],
  [190, 5100, 2280, 1201.69],
  [195, 5250, 2340, 1233.31],
  [200, 5400, 2400, 1264.94],
  [205, 5560, 2460, 1296.56],
  [210, 5710, 2520, 1328.18],
  [215, 5860, 2580, 1359.81],
  [220, 6020, 2640, 1391.43],
  [225, 6170, 2700, 1423.05],
  [230, 6320, 2760, 1454.68],
  [235, 6475, 2820, 1486.3],
  [240, 6625, 2880, 1517.92],
  [245, 6780, 2940, 1549.55],
  [250, 6930, 3000, 1581.17],
  [255, 7085, 3060, 1612.79],
  [260, 7240, 3120, 1644.42],
  [265, 7270, 3180, 1676.04],
  [270, 7420, 3240, 1707.66],
  [275, 7575, 3300, 1739.29],
  [280, 7725, 3360, 1770.91],
  [285, 7880, 3420, 1802.53],
  [290, 8030, 3480, 1834.16],
  [295, 8180, 3540, 1865.78],
  [300, 8335, 3600, 1897.4],
];

export default salarySacrificeTable;
